import { Checkbox, Div, Link, ModalWindow } from '@tblabs/truffle';
import { PrimaryButton } from '../../General/Buttons/PrimaryButton';
import { DefaultButton } from '../../General/Buttons/DefaultButton';
import { CopyToClipboard } from '../../../Utils/CopyToClipboard';
import { Translations } from '../../../Translations/Translations';
import { SavingPictureMoreInfoWindow } from './SavingPictureMoreInfoWindow';
import { Svg } from '../../General/Svg';
import { Icons } from '../../Icons';
import { SnapStorage } from '../../../Services/Storage/SnapStorage';


export class SnapsSavingWindow extends ModalWindow
{
    constructor(_storage: SnapStorage, _lang: Translations)
    {
        super(_lang.PicturesSaving, true, false, true);

        this.AddContent(
            new Div().Append(
                // new Div().Append(
                //     new Svg(Icons.Desktop).MarginRight(4).Color("#8a8a8a"),
                //     _lang.SaveOnDesktop,
                // ),
                new Div().Append(
                    new Svg(Icons.Server).MarginRight(4).Color("#8a8a8a"),
                    _lang.SaveOnServer,
                )
            ),

            new Div().MarginTop(20).Append(
                new PrimaryButton(_lang.OpenSavedOnServer)
                    .OnClick(() => window.open(_storage.OnlineStorage.Link, "_blank")),
                new DefaultButton(_lang.CopyAddress, (btn) =>
                {
                    CopyToClipboard(_storage.OnlineStorage.Link);
                    btn.Label(_lang.Copied)
                }),
            ),

            new Div().MarginTop(12).Append(
                new Checkbox(_storage.AutoSaveOnServer, _lang.AutoSaveOnServer).Class("checkbox")
            )
        )

        this.AddToFooter(
            new Div().DisplayInlineBlock().MarginTop(8).FloatLeft()
                .OnClick(() => new SavingPictureMoreInfoWindow(_lang, _storage.WatcherId))
                .Append(
                    new Svg(Icons.Info).Color("#1e87f0"),
                    new Link(_lang.MoreInfo).Style("transform: translatey(1px); display: inline-block; margin-left: 4px; color: #1e87f0;"),
                ),

            new DefaultButton(_lang.Close, () => this.CloseWindow())
        )

        this.OpenWindow()
    }
}

